/** Public service entry points match the Ostart header; credentials stay in each service. */
export function serviceNavigation(showChats: () => void): HTMLElement {
  const nav = document.createElement('nav'); nav.className = 'service-navigation'; nav.setAttribute('aria-label', 'Сервисы Ostart');
  const services = [
    {label: 'Чат', href: '/', icon: '<path d="M21 11a8 8 0 0 1-8 8H8l-5 3 2-6a8 8 0 1 1 16-5Z"/>'},
    {label: 'Почта', href: 'https://m.ostart.ru/?sso=1', icon: '<rect x="3" y="5" width="18" height="14" rx="2"/><path d="m3 6 9 7 9-7"/>'},
    {label: 'Файлы', href: 'https://f.ostart.ru/', icon: '<path d="M3 7a2 2 0 0 1 2-2h4l2 2h8a2 2 0 0 1 2 2v10H3Z"/>'},
  ];
  for (const service of services) {
    const link = document.createElement('a'); link.href = service.href; link.title = service.label; link.setAttribute('aria-label', service.label);
    link.innerHTML = `<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${service.icon}</svg>`;
    if (service.label === 'Чат') { link.setAttribute('aria-current', 'page'); link.addEventListener('click', event => {
      if (event.button || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
      event.preventDefault(); showChats();
    }); }
    nav.append(link);
  }
  return nav;
}
